import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

interface ImportDutiesPayload {
  file: File;
}

export const useAdminImportDuties = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: ImportDutiesPayload) => {
      const formData = new FormData();
      formData.append('file', payload.file);

      return apiClient.duty.updateTaricDuty.mutation({
        body: formData,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin-catalogs-info'] });
      toast.success('Duties imported successfully');
    },
    onError: (error: unknown) => {
      showErrorToast(error, 'Failed to import duties');
    },
  });
};
